import {type LogoutOptions} from '@auth0/auth0-react';
import {type GetTokenSilentlyOptions} from '@auth0/auth0-spa-js/dist/typings';
import {type InternalAxiosRequestConfig} from 'axios';
import {getAuth0LogoutRedirect} from '../utils/runtimeVars';
import {buildVersion} from '../utils/buildVersion';

export async function onRequest({
  config,
  getAccessTokenSilently,
  logout,
}: {
  config: InternalAxiosRequestConfig;
  getAccessTokenSilently: (options?: GetTokenSilentlyOptions | undefined) => Promise<string>;
  logout: (options?: LogoutOptions | undefined) => void;
}): Promise<InternalAxiosRequestConfig<any>> {
  let token: string | undefined;
  if (config.headers) {
    try {
      token = await getAccessTokenSilently();
    } catch {
      logout({logoutParams: {returnTo: getAuth0LogoutRedirect()}});
    }
  }

  if (token) {
    config.headers.authorization = `Bearer ${token}`;
  }

  if (config.headers && !config.headers.has('oa-frontend-build-version')) {
    config.headers.set('oa-frontend-build-version', buildVersion);
  }

  return config;
}
